<template>
    <div id="cartFlyout" class="flyout">
        <div class="backdrop" v-on:click="this.hide" v-if="isOpen"></div>
        <div class="flyout-container" :class="{ open: isOpen }">
            <div class="header">
                <a class="close-button" v-on:click="this.hide">
                    <i class="material-icons" aria-hidden="true">keyboard_arrow_right</i><span class="sr-only sr-only-focusable">{{ __('Close') }}</span>
                </a>
                <span class="title">{{ __('Shopping Cart Preview') }}</span>
            </div>
            <div class="content">
                <ul class="items">

                    <li v-for="(item, key, index) in items">
                        <div class="item">
                            <div class="preview-image aspect-ratio-box ratio-16-9">
                                <div class="aspect-image-container">
                                    <picture>
                                        <source :srcset="item.options.preview_image_webp" type="image/webp">
                                        <source :srcset="item.options.preview_image" type="image/jpeg">
                                        <img :src="item.options.preview_image" width="85" :alt="item.name">
                                    </picture>
                                </div>
                            </div>
                            <span class="item-name">{{ item.name }}</span>
                            <span class="price">
                                <small class="text-muted" v-if="item.qty > 1">{{ __('Quantity') }}: {{ item.qty }}</small>
                                <br>
                                <strong class="text-nowrap">{{ getItemPrice(item) }} €</strong>
                            </span>
                        </div>
                        <small v-if="index === count - 1" class="indicator iconized">
                            <i class="material-icons" aria-hidden="true">check_circle</i>
                            <span>{{ __('Successfully added') }}</span>
                        </small>
                    </li>

                </ul>
            </div>
            <div class="footer">
                <div class="summary">
                    <span>{{ __('Total') }}</span>
                    <small class="x-small text-muted text-nowrap">{{ __('including VAT') }} {{ vat }}%</small>
                    <small class="spacer">&nbsp;</small>
                    <strong class="amount text-nowrap">{{ total }} €</strong>
                </div>
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>

  import trans from '../mixins/trans';

    export default {

        mixins: [
          trans
        ],

        props: [
            'vat'
        ],

        data() {
            return {
                isOpen: false,
                total: null,
                items: [],
                count: 0
            };
        },

        mounted() {
            this.update();
        },

        methods: {

            update() {
                axios.get('/api/warenkorb')
                    .then(({data}) => {
                        this.total = data.total;
                        this.items = data.items;
                        this.count = Object.keys(this.items).length;
                    })
            },

            show() {
                this.update();
                this.isOpen = true;
                document.documentElement.style.overflow = 'hidden';
            },

            hide() {
                this.isOpen = false;
                document.documentElement.style.overflow = '';
            },

            getItemPrice(item) {
                const total = parseFloat(item.subtotal) + parseFloat(item.tax);
                return total.toFixed(2).replace('.', ',');
            }
        }

    }
</script>